module.exports = __webpack_public_path__ + "img/bus-homepage.df751cc5.svg";